const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const ScrollEvents = function () {

    const animeTextIntro = (el) => {

        const elem = document.querySelector(el);

        if(!elem) return;

        // swiftUpElements.forEach(elem => {

        const words = elem.textContent.split(' ');
        elem.innerHTML = '';

        words.forEach((el, index) => {
            words[index] = `<span><i>${words[index]}</i></span>`;
        });

        elem.innerHTML = words.join(' ');

        const children = document.querySelectorAll('span > i');
        children.forEach((node, index) => {
            node.style.animationDelay = `${index * .1}s`;
        });

        // });
    }

    const scrollBlur = () => {

        const circles = document.querySelector("#scroll-circle");

        if(!circles) return;

        const ww = window.innerWidth;
        const wh = window.innerHeight;
        const circleRadius = circles.clientWidth / 2;

        // gsap.set(circles, {
        //     x: gsap.utils.random(circleRadius, ww - circleRadius),
        //     y: gsap.utils.random(circleRadius, wh - circleRadius)
        // });

        // gsap.set(circles, {
        //     xPercent: -50,
        //     yPercent: -50,
        // });
        
        const s3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#section-elm-blur",
                scrub: true,
                start: circles.classList.contains('circle-blur-small') ? "top center" : "20% center",
                end: "bottom+=100% top",
                id: "collecting",
                toggleClass: {targets: ".circle-blur-small", className: 'circ-fixed'},
                // markers: true,
            }
        }).to(circles, {
            duration: .5,
            position:'fixed',
            x: circles.classList.contains('circle-blur-small') ? '55vw' : '40vw',
            y: circles.classList.contains('circle-blur-small') ? '15vh' : 0,
            // border : '2px solid red',
            scale : circles.classList.contains('circle-blur-small') ? 1.6 : .4,
            ease: "none"
        }).to(circles, {
            // border : '2px solid blue',
            duration: 1,
            x: circles.classList.contains('circle-blur-small') ? '-100%' : '0vw',
            y: circles.classList.contains('circle-blur-small') ? '-50%' : 0,
            ease: "none",
            scale : .7
        }).to(circles, {
            // border : '2px solid green',
            duration: 1,
            x: '0vw',
            y: '5vh',
            ease: "none",
            scale : .3
        })

    }

    const parallaxWebdoor = function (el) {

        gsap.fromTo($(el).not(".no-plx").find('img, video'),
            {
                yPercent: 0,
                scale: 1,
            }, {
            yPercent: 35,
            scale: 1.2,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "top top",
                end: "bottom -=50%",
                scrub: true
            }
        });

        gsap.fromTo($(el).not(".no-plx").find('p, h2'),
            {
                yP: 0,
            }, {
            y: 350,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "center 45%",
                end: "bottom -=50%",
                scrub: true
            }
        });
    }


    const elmToScroll = function (el) {
        var _this = el.attr('data-scrollto');
        console.log(_this);
        scrollToElm(_this);
    }

    const scrollToElm = function (target) {
        gsap.to(window, {
            duration: 0,
            scrollTo: (document.querySelector(target).offsetTop - document.querySelector('header').clientHeight),
            ease: 'Expo.easeOut',
        }
        );
    }

    const elmWebdoorScroll = (() => {

        const logoWebdoor = document.querySelector('.scroll-elm-webdoor');

        gsap.to(logoWebdoor, {
            yPercent: 35,
            scale: "+=0.5",
            autoAlpha: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".webdoor",
                start: "top top",
                end: "bottom +=100",
                scrub: true
            }
        });

    })

    const expImage = (() => {
        gsap.utils.toArray(".revealUp").forEach(el => {
            gsap.fromTo(el,
                {
                    scale: 1.3,
                    yPercent: 45
                }, {
                yPercent: 0,
                scale: 1,
                autoAlpha: 1,
                ease: "none",
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom",
                    end: "center bottom",
                    scrub: 1,
                    // markers : true
                }
            });
        })

    })


    const layerMaskAnimation = (() => {
        gsap.utils.toArray(".mask-layer-animation").forEach(el => {
            gsap.to(el, {
                //height: 0,
                ease: "power4.out",
                duration: 1,
                scrollTrigger: {
                    trigger: el,
                    start: "top center",
                    end: "center top",
                    scrub: 2,
                    toggleClass: 'motion-in'
                }
            });
        })

    })

    const footerAnimate = (() => {

        const elmFooter = document.querySelector("footer");
        gsap.from(elmFooter, {
            scrollTrigger: {
                start: 'top center',
                trigger: elmFooter,
                onEnter: () => {
                    elmFooter.classList.add('motion-in');
                    $("#header-logo").fadeOut(100);
                },
                onLeaveBack: () => {
                    elmFooter.classList.remove('motion-in');
                    $("#header-logo").fadeIn(100);
                }
                // toggleClass: 'motion-in',
                // markers : true
            }
        });

    });

    return {

        animeTextIntro: animeTextIntro,


        init: function (el) {

            if ($(".webdoor-intro").length > 0) {
                parallaxWebdoor(".webdoor-intro");
            }

            // circulo scrollando
            scrollBlur();

            //logo home
            if (document.querySelector('.scroll-elm-webdoor')) {
                elmWebdoorScroll();
            }

            if (document.querySelector('.mask-layer-animation')) {
                layerMaskAnimation();
            }


            expImage();
            footerAnimate();


            $(document).on('click', '[data-scrollto]', function () {
                elmToScroll($(this));
            });

            //quando ajax carregado forca ir topo da pagina
            if (el) {
                scrollToElm(el);
            }

        }
    }

}();

export default ScrollEvents;